import { Card } from '../../../utilities/components';
import React, { useEffect, useState } from 'react';
import { getReferralActions } from '../referral.service';
import { Pagination, ReferralAction } from '../../../interfaces';
import moment from 'jalali-moment';
import { Table } from '../../components';
import { ConfigProvider, Pagination as AntPagination, TableColumnsType } from 'antd';
import fa_IR from 'antd/locale/fa_IR';

export const ReferralActions = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [actions, setActions] = useState<Pagination<ReferralAction>>();
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);

    const columns: TableColumnsType<any> = [
        {
            title: 'ردیف',
            dataIndex: 'id',
            key: 'id',
            render: (text, record, i) => <span className={'font-medium text-sm'}>{i + 1}</span>,
        },
        {
            title: 'پاداش',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, record) => (
                <span className={'font-medium text-sm'}>{record?.amount?.toLocaleString()} تومان</span>
            ),
        },
        {
            title: 'موجودی پس از تراکنش',
            dataIndex: 'balanceAfterTransaction',
            key: 'balanceAfterTransaction',
            render: (pair, record) => (
                <span className={'text-sm font-medium'}>{record?.balanceAfterTransaction?.toLocaleString()} تومان</span>
            ),
        },
        {
            title: 'تاریخ',
            dataIndex: 'createdOn',
            key: 'createdOn',
            render: (text, record) => (
                <span className={'font-medium text-sm'}>
                    {moment.utc(record?.createdOn).locale('fa').local().format('jD jMMMM jYYYY، ساعت HH:mm')}
                </span>
            ),
        },
    ];

    const handlePageChange = (page: number, pageSize: number) => {
        setPage(page);
        setPageSize(pageSize);
    };

    const fetchData = (page: number, pageSize: number) => {
        getReferralActions(setLoading, setActions, page, pageSize);
    };

    useEffect(() => {
        fetchData(page, pageSize);
    }, [page, pageSize]);

    return (
        <Card size={'small'} title={'تراکنش دوستان'} titleDivider noPadding className={'w-full'}>
            <Table
                className={'border-0'}
                columns={columns}
                dataSource={actions?.items}
                loading={loading}
                rowKey="id"
                pagination={false}
            />
            <ConfigProvider locale={fa_IR}>
                <AntPagination
                    current={page}
                    pageSize={pageSize}
                    total={actions?.pagination.totalCount}
                    onChange={handlePageChange}
                    className="mt-4 justify-center"
                    style={{ direction: 'ltr' }}
                    showSizeChanger={true}
                    onShowSizeChange={(current, size) => handlePageChange(current, size)}
                />
            </ConfigProvider>
        </Card>
    );
};
